import React from 'react'
import PropTypes from 'prop-types'
import { Modal } from 'components'
import styles from './CampaignModal.module.scss'

const CampaignModal = ({ closeModal, opened }) => {
  return (
    <Modal
      opened={opened}
      closeModal={closeModal}
      className={styles.modalCamp}
      closeClassName={styles.closeButtonCamp}
    >
      <section className={styles.campaignModal}>
        <header className={styles.text}>
          Descubra os imóveis
          <br />
          <span className={styles.bold}>
            com até 70% de desconto do Banco do Brasil!
          </span>
        </header>

        <a
          href="https://seuimovelbb.com.br/?utm_source=resale&utm_medium=redirect"
          target="_blank"
          rel="noopener noreferrer"
          className={styles.button}
        >
          acesse e cadastre-se
        </a>
      </section>
    </Modal>
  )
}

CampaignModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  opened: PropTypes.bool.isRequired,
}

export default React.memo(CampaignModal)
